<template lang="pug">
  button.btn(
    :class="[`btn__${theme}`, `h-${size}`]"
    @click.prevent="eventClick"
  ) {{ label }}
</template>
<script>
export default {
  name: 'Button',
  props: {
    theme: {
      type: String,
      default: 'default'
    },
    size: {
      type: String,
      default: 'medium'
    },
    label: {
      type: String,
      required: true
    }
  },
  methods: {
    eventClick () {
      this.$emit('onClick', true)
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "@/assets/style/_variables";

  .btn {
    border-radius: 28px;
    cursor: pointer;
    font-weight: bold;
    font-size: 16px;
    font-family: $oscine-font-family;
    transition: background-color .4s;
    width: 100%;

    &__default {
      background-color: #1A71B4;
      color: #fff;

      &:hover {
        background-color: #3e90cf;
      }
    }

    &__outlined {
      border: solid 1px #1A71B4;
      color: #373739;

      &:hover {
        background-color: #1a71b417;
      }
    }

    &:disabled {
      cursor: no-drop;
      opacity: 0.3;
    }
  }
</style>
